import React from "react";

import Header from "../components/Header";

import Inicio from "./Inicio";

import {
  withRouter,
} from "react-router-dom";

class Contenido extends React.Component {
  constructor(props) {
    super(props);
    this.state = { opcInicio: null };
    this.childHandler = this.childHandler.bind(this);
  }

  componentDidUpdate() {
    /*
    var dv = document.getElementById("dv_subCont");
    const { cont, datos } = this.props;
    const { opcInicio } = this.state;
    if (cont === "Inicio") {
      ReactDom.render(<Inicio action={this.childHandler} menu={datos} />, dv);
    } else if (cont.codigoVista === "AdminVista") {
      ReactDom.render(<Vistas />, dv);
    } else if (cont.codigoVista === "usrs") {
      ReactDom.render(<Usuarios />, dv);
    } else if (cont === "Inicio" && opcInicio !== null) {
      const { descripcionMenu, idVista, urlReporte } = opcInicio;
      ReactDom.render(
        <Reporte
          report={descripcionMenu}
          idMenu={idVista}
          url={idVista === 26 ? urlReporte : null}
        />,
        dv
      );
    } else {
      ReactDom.render(<Reporte report={cont.idVista} idMenu={cont.idVista} />, dv);
    }
    */
  }

  childHandler(datosHijo) {
    const { history } = this.props;
    this.setState({ opcInicio: datosHijo }, () => {
      history.push(`/reporte/${btoa(datosHijo.idVista)}/${btoa(datosHijo.descripcion)}`);
    });
  }

  render() {
    const {  datos } = this.props;
    return (
      <div className="dv_cont" id="dv_contenido">
        <Header />
        <div id="dv_subCont">
          <Inicio action={this.childHandler} menu={datos} />
        </div>
      </div>
    );
  }
}

export default withRouter(Contenido);
